import React from "react";
import "../styles/NotFound.css";
import notFoundImg from "../assets/404.png"; // your image

const NotFound = () => {
  return (
    <div className="notfound-container">
      <img src={notFoundImg} alt="404 Not Found" className="notfound-image" />
    </div>
  );
};

export default NotFound;